import { Text } from '@mantine/core';
import { FC } from 'react';

interface HeaderProps {
  title: string;
  description: string;
  titleIcon?: FC;
}

export default ({ description, title, titleIcon: Icon }: HeaderProps) => {
  return (
    <section className="flex flex-col items-center justify-center">
      {Icon && <Icon />}
      <h1 className="text-[32px]">{title}</h1>
      <Text className="mt-2" color="gray.5">
        {description}
      </Text>
    </section>
  );
};
